import React from "react";
import { MdHome } from "react-icons/md";
import "./HomeEmptyCard.css";

const HomeEmptyCard = ({activeTab}) => {

  return (
    <div className="no-properties-message">
      {activeTab !== 'alerts' && <MdHome className="home-empty-card-icon" /> }
      <div className="home-empty-card-message">{activeTab === 'saved-properties' ? 'You have not saved any properties yet.' : activeTab === 'alerts' ? "All Caught Up!" :  'Sorry, No Properties Found!'}</div>
      {activeTab === 'saved-properties' && <div className="home-empty-card-description">
        <a className="home-empty-card-link" href="/auctions?listingType=AUCN">Click here</a> to browse all available auctions or start your search above
      </div>}

       {activeTab === 'alerts' && <div className="home-empty-card-description">
      You have no new notifications!


      </div>}
    </div>
  );
};

export default HomeEmptyCard;